import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, Search, MapPin, Clock, ChevronRight } from 'lucide-react';

const Kariyer = () => {
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const departments = [
    { value: 'all', label: 'Tüm Departmanlar' },
    { value: 'finance', label: 'Finans' },
    { value: 'investment', label: 'Yatırım' },
    { value: 'tech', label: 'Teknoloji' },
    { value: 'hr', label: 'İnsan Kaynakları' }
  ];

  const jobListings = [
    {
      id: 1,
      title: 'Kıdemli Portföy Yöneticisi',
      department: 'investment',
      location: 'İstanbul',
      type: 'Tam Zamanlı',
      description: 'Portföy yönetimi konusunda deneyimli profesyoneller arıyoruz.'
    },
    {
      id: 2,
      title: 'Finansal Analist',
      department: 'finance',
      location: 'İstanbul',
      type: 'Tam Zamanlı',
      description: 'Finansal analiz ve raporlama konusunda yetenekli adaylar bekliyoruz.'
    },
    {
      id: 3,
      title: 'Yazılım Geliştirici',
      department: 'tech',
      location: 'İstanbul',
      type: 'Tam Zamanlı',
      description: 'React ve Node.js konusunda deneyimli geliştiriciler arıyoruz.'
    },
    {
      id: 4,
      title: 'İnsan Kaynakları Uzmanı',
      department: 'hr',
      location: 'İstanbul',
      type: 'Tam Zamanlı',
      description: 'İK süreçlerinde deneyimli profesyoneller aramaktayız.'
    }
  ];

  const filteredJobs = selectedDepartment === 'all' 
    ? jobListings 
    : jobListings.filter(job => job.department === selectedDepartment);

  return (
    <div className="min-h-screen">
      {/* Hero */}
      <div className="relative h-96 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 flex items-center">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.02) 35px, rgba(255,255,255,.02) 70px)'
          }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-6xl font-bold text-white mb-4">Kariyer</h1>
          <p className="text-slate-300 text-xl max-w-2xl">Ekibimize katılın ve kariyerinizi bir üst seviyeye taşıyın</p>
        </div>
      </div>

      {/* Why Join Us */}
      <div className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Neden Turkish Menkul Değerler?</h2>
            <p className="text-slate-600 text-lg">120 yılı aşkın tecrübeye sahip dinamik bir ekipte kariyer fırsatları</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-slate-50 rounded-xl p-6 text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Briefcase className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Profesyonel Gelişim</h3>
              <p className="text-slate-600">Sürekli eğitim ve gelişim imkanları</p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Search className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Kariyer Fırsatları</h3>
              <p className="text-slate-600">Geniş kariyer yolları ve terfi imkanları</p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2">Uluslararası Ortam</h3>
              <p className="text-slate-600">3 ülkede faaliyet gösteren global ekip</p>
            </div>
          </div>
        </div>
      </div>

      {/* Job Listings */}
      <div className="py-16 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-slate-900 mb-8">Açık Pozisyonlar</h2>

            {/* Filter */}
            <div className="mb-8">
              <select
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
                className="px-4 py-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white"
              >
                {departments.map(dept => (
                  <option key={dept.value} value={dept.value}>{dept.label}</option>
                ))}
              </select>
            </div>

            {/* Jobs */}
            <div className="space-y-4">
              {filteredJobs.map(job => (
                <div key={job.id} className="bg-white rounded-xl p-6 border border-slate-200 hover:shadow-lg transition-shadow">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className="flex-1 mb-4 md:mb-0">
                      <h3 className="text-xl font-semibold text-slate-900 mb-2">{job.title}</h3>
                      <p className="text-slate-600 mb-3">{job.description}</p>
                      <div className="flex flex-wrap gap-3 text-sm text-slate-500">
                        <div className="flex items-center space-x-1">
                          <MapPin className="w-4 h-4" />
                          <span>{job.location}</span>
                        </div>
                        <div className="flex items-center space-x-1">
                          <Clock className="w-4 h-4" />
                          <span>{job.type}</span>
                        </div>
                      </div>
                    </div>
                    <Link
                      to="/basvurmak"
                      className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg hover:shadow-orange-500/50 transition-shadow flex items-center space-x-2"
                    >
                      <span>Başvur</span>
                      <ChevronRight className="w-5 h-5" />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kariyer;